var map = {
	"./alert.svg": "1540",
	"./alias.svg": "17d9",
	"./analogo.svg": "4f9d",
	"./cabeza_danger.svg": "88a8",
	"./cabeza_success.svg": "7903",
	"./cabeza_warning.svg": "9122",
	"./clock.svg": "0fbd",
	"./co2.svg": "da26",
	"./co2_blue.svg": "1020",
	"./co2_gray.svg": "cda0",
	"./co2_green.svg": "a3a5",
	"./co2_red.svg": "a390",
	"./co2_warning.svg": "f7cd",
	"./co2_white.svg": "9397",
	"./cpu.svg": "38fe",
	"./envtemperature.svg": "5a6f",
	"./fecha.svg": "5ae0",
	"./home-device-icon.svg": "de29",
	"./humedad.svg": "0455",
	"./humedad_blue.svg": "9cf1",
	"./humedad_gray.svg": "3a4c",
	"./humedad_green.svg": "dcef",
	"./humedad_red.svg": "1725",
	"./humedad_white.svg": "5197",
	"./humidity.svg": "efe0",
	"./notification.svg": "b17b",
	"./phone.svg": "a3f6",
	"./pressure.svg": "ac4e",
	"./pressure_blue.svg": "e477",
	"./pressure_gray.svg": "3f46",
	"./pressure_label.svg": "d9dd",
	"./pressure_red.svg": "8c77",
	"./relay.svg": "6c85",
	"./smile_danger.svg": "e3bb",
	"./smile_success.svg": "514d",
	"./smile_warning.svg": "df00",
	"./spore_icon.svg": "31b1",
	"./statistics.svg": "7a7b",
	"./suenio_danger.svg": "1f72",
	"./suenio_success.svg": "5164",
	"./suenio_warning.svg": "5d6e",
	"./temperature.svg": "1811",
	"./temperature_blue.svg": "f1ac",
	"./temperature_gray.svg": "624a",
	"./temperature_green.svg": "5e34",
	"./temperature_red.svg": "6f62",
	"./temperature_white.svg": "def0",
	"./tick-icon.svg": "68f6",
	"./ventilador_danger.svg": "2433",
	"./ventilador_success.svg": "ca5b",
	"./ventilador_warning.svg": "7129"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0bd";